<template>
    <article class="product">
        <div class="product-header">
            <div class="product-employee">
                <img :src="employeeImageUrl" :alt="employeeName">
            </div>
            <div class="product-description">
                {{ product.description }}
            </div>
            <div class="product-spiral">
                <img src="/images/icons/spirale-pleine.png" alt="spirale">
            </div>
        </div>
        <div class="product-content">
            <a :href="productUrl">
                <img class="product-image" :src="productImageUrl" :alt="product.name">
            </a>
            <div class="product-content-overlay">
                <div class="product-icons-container">
                    <a @click.prevent="addToFavorites" href="#" title="ajouter à mes coups de coeur">
                        <img v-if="isInFavorites" class="icon-coeur" src="/images/icons/coeur-rouge.png"
                             alt="coup de coeur">
                        <img v-else class="icon-coeur" src="/images/icons/coeur-blanc.png" alt="coup de coeur">
                    </a>
                    <a :href="productUrl" title="voir le produit">
                        <img class="icon-info" src="/images/icons/information.png" alt="information">
                    </a>
                </div>
                <div class="product-tags">
                    <a v-for="tag in product.tags" :href="tagUrl(tag)" class="product-tag">
                        #{{ tag.name }}
                    </a>
                </div>
            </div>
        </div>
    </article>
</template>

<script>
  import store from './../store'

  export default {
    name: 'product',
    props: {
      product: {
        type: Object,
        required: true
      }
    },
    data () {
      return {
        state: store.state
      }
    },
    computed: {
      employeeImageUrl () {
        return this.product.employee.images.small_image_url
          || this.product.employee.images.default_small_image_url
      },
      employeeName () {
        return this.product.employee.name
      },
      isInFavorites () {
        return new Set(store.getFavoriteProducts()).has(this.product.id)
      },
      productImageUrl () {
        return this.product.images.big_image_url
          || this.product.images.default_big_image_url
      },
      productUrl () {
        return `/produits/${this.product.slug}`
      }
    },
    methods: {
      addToFavorites () {
        return this.$root.addToFavorites(this.product.id)
      },
      tagUrl (tag) {
        return `/produits?tag=${tag.slug}`
      }
    }
  }
</script>
